'use strict';

var JQXTreeNodeSplitterFactory = function JQXTreeNodeSplitterFactory(Node) {
  function prepareSplitterHtml() {
    return '<div class="jqx-tree-splitter fa fa-lock"><div class="jqx-tree-splitter-line"></div></div>';
  }
  function SplitterNode(uniqueId) {
    Node.call(this, {
      id: '_splitter-' + uniqueId,
      label: null,
      checked: false,
      selected: false,
      frozen: false,
      custom: false
    });
    this.html = prepareSplitterHtml();
    this.checkboxVisibility = false;
  }
  SplitterNode.prototype = Object.create(Node.prototype);
  SplitterNode.prototype.constructor = SplitterNode;
  return SplitterNode;
};
JQXTreeNodeSplitterFactory.$inject = ['JQXTreeNodeFactory'];
module.exports = JQXTreeNodeSplitterFactory;